import React from 'react';
import '@fullcalendar/react/dist/vdom';
import FullCalendar from '@fullcalendar/react';
import esLocale from '@fullcalendar/core/locales/es';
import dayGridPlugin from '@fullcalendar/daygrid';
import bootstrapPlugin from '@fullcalendar/bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fullcalendar/daygrid/main.css';

var main = '';

const Theme = (props) => props.children;

const ReactCalendar = ({ ...rest }) => {
  return /* @__PURE__ */ React.createElement(Theme, null, /* @__PURE__ */ React.createElement(FullCalendar, {
    plugins: [bootstrapPlugin, dayGridPlugin],
    locale: esLocale,
    firstDay: 0,
    aspectRatio: 2,
    dayMaxEvents: true,
    themeSystem: "bootstrap",
    initialView: "dayGridMonth",
    headerToolbar: { start: "", center: "title", end: "" },
    titleFormat: { year: "numeric", month: "long" },
    ...rest
  }));
};

export { ReactCalendar as default };
//# sourceMappingURL=index.es.js.map
